import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { toggleChatPanelVisible } from '../../reducers/ui/actions';
import withConfig from '../../context/withConfig';
import CloseIcon from '../icons/CloseIcon';
import OpenStateListener from '../OpenStateListener';
import DefaultLauncherSvg from './DefaultLauncherSvg';

const LauncherWrapper = styled.div`
  height: 60px;
  width: 60px;
  border-radius: 30px;
  background-color: ${props => props.theme.accentColor};
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.09), 0 2px 15px 0 rgba(0, 0, 0, 0.15);

  position: fixed;
  top: 15px;
  left: 15px;

  cursor: pointer;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 11px;
  right: 11px;
  width: 38px;
  height: 38px;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: 0.5s;
`;

const Avatar = styled.img`
  display: block;
  width: 100%;
`;

const UnreadMessages = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 9999;
  background: #e02020;
  color: #fff;
  font-size: 12px;
  border: 2px solid #fff;
`;

export class Launcher extends Component {
  state = {
    unreadMessages: 0
  };

  updateUnreadMessageCount = e => {
    const message = e.data;

    // See initialiser for message source
    if (message.type === 'unreadMessages') {
      this.setState({
        unreadMessages: message.count
      });
    }
  };

  componentWillMount() {
    window.addEventListener('message', this.updateUnreadMessageCount);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.updateUnreadMessageCount);
  }

  handleLauncherClick = () => {
    this.props.toggleChatPanelVisible();
  };

  render() {
    const { config, chatPanelVisible } = this.props;
    const { unreadMessages } = this.state;

    return (
      <LauncherWrapper onClick={this.handleLauncherClick} data-test-id="launcher">
        {unreadMessages > 0 ? (
          <UnreadMessages data-test-id="unreadMessages">{unreadMessages}</UnreadMessages>
        ) : null}
        <OpenStateListener />
        <IconWrapper visible={chatPanelVisible}>
          <CloseIcon />
        </IconWrapper>
        <IconWrapper visible={!chatPanelVisible}>
          {config.images.launcher ? (
            <Avatar src={config.images.launcher} data-test-id="launcherAvatar" />
          ) : (
            <DefaultLauncherSvg />
          )}
        </IconWrapper>
      </LauncherWrapper>
    );
  }
}

export default connect(
  state => ({
    chatPanelVisible: state.ui.chatPanelVisible
  }),
  { toggleChatPanelVisible }
)(withConfig(Launcher));



// WEBPACK FOOTER //
// ./src/components/Launcher/index.js